function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#7C8084"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.239.397c.035.023.061.043.086.065l.01.008.014.013.04.04.031.035c.122.146.186.333.159.53-.003.008-.004.017-.005.026-.003.02-.008.04-.014.06-.003.014-.008.027-.012.04l-.012.034-4.76 12c-.255.64-1.267.677-1.58.057L6.61 8.168.79 5.885C.084 5.61.125 4.717.852 4.492L14.437.297l.011-.004h.005l.032-.01c.028-.008.055-.014.083-.019.201-.037.396-.006.56.07.003.003.007.005.01.006.03.014.059.03.086.047l.015.01zM12.7 3.854L8.266 7.766l1.613 3.2L12.7 3.855zm-1.2-1.061l-8.062 2.49 3.626 1.423L11.5 2.793z",
  transform: "translate(-622 -281) translate(443 94) translate(179 187) translate(0 1)"
}))))));

var SvgIconsGlobalContactEmailGray = function SvgIconsGlobalContactEmailGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconsGlobalContactEmailGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons-global-contact-email-gray.07ef8bb6.svg";
export { ForwardRef as ReactComponent };